<template>
    <section class="row mt-3 section-news">
        <div class="container">
            <div class="row">
                <div class="col-12">
                    <div class="row">
                        <h1 class="section-title">Tin tức</h1>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-12 col-lg-6 mb-3 post-item" v-for="(newsItemValue, newsItemIndex) in newsList" :key="'newsItem' + newsItemIndex">
                    <router-link :to="{name: 'NewsDetailPageComponent', params: {slug: newsItemValue.postSlug}}">
                        <div class="row no-gutters">
                            <div class="col-5 post-item-image">
                                <div class="row no-gutters">
                                    <img class="img-thumbnail" :src="assetsBaseUrl + newsItemValue.postImage">
                                </div>
                            </div>
                            <div class="col-7">
                                <div class="row no-gutters">
                                    <div class="col-12 post-item-time">{{ newsItemValue.postCreatedAt }}</div>
                                    <div class="col-12 post-item-title">{{ newsItemValue.postTitle }}</div>
                                    <div class="col-12 mt-1 post-item-description">{{ newsItemValue.postIntro }}</div>
                                </div>
                            </div>
                        </div>
                    </router-link>
                </div>
            </div>
            <div class="row mt-1">
                <div class="col-12 text-center">
                    <router-link :to="{name: 'NewsPageComponent'}" class="btn btn-danger font-weight-bold pt-2 pb-2 pl-5 pr-5">Xem thêm</router-link>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
    /**
     * Import modules
     */
    import * as _ from 'lodash';

    export default {
        name: "NewsComponent",
        data() {
            return {
                assetsBaseUrl: process.env.VUE_APP_API_DOMAIN,
                newsList: null
            }
        },
        mounted() {
            // get top-slider items list
            this.newsList = _.take(this.$store.state.news.newsList, 4);
        }
    }
</script>

<style scoped>

</style>
